/**
 * Flow Trigger Types and Options
 * Defines the available trigger types for email flows
 */

import { FLOW_TRIGGER, type FlowTrigger } from '@/lib/api/email-flows/types';

// Re-export from API types (single source of truth)
export { FLOW_TRIGGER, type FlowTrigger };

export interface TriggerOption {
    value: FlowTrigger;
    label: string;
}

export const TRIGGER_OPTIONS: TriggerOption[] = [
    {
        value: FLOW_TRIGGER.CHECKOUT,
        label: 'I want to send them after a product purchase',
    },
    {
        value: FLOW_TRIGGER.TIME,
        label: 'I want to send them on a specific date',
    },
    {
        value: FLOW_TRIGGER.CART_ABANDONMENT,
        label: 'I want to send them after cart abandonment',
    },
];
